<template>
  <div class="app-wrapper">
    <navbar />
    <div class="main-container">
      <simple-sidebar class="sidebar-container" />
      <div class="app-main">
        <app-main />
      </div>
    </div>
  </div>
</template>

<script>
import AppMain from './components/AppMain'
import Navbar from './components/Navbar'
import SimpleSidebar from './components/SimpleSidebar'

export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    SimpleSidebar
  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-container {
  flex: 1;
  display: flex;
  overflow: hidden;
}

.sidebar-container {
  width: 210px;
  height: 100%;
  transition: width 0.28s;
}

.app-main {
  flex: 1;
  overflow: auto;
  padding: 20px;
  background-color: $mainBg;
}
</style> 